import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getEntryById } from './registry'
import { getEntryByPath } from './index'

// Recently visited pages, shown at the top of the sidebar. Stored in
// localStorage rather than uiPreferences on purpose: it's written on every
// navigation, is naturally per-device, and losing it costs nothing - none of
// which suits a server round-trip + user-state update per click.

const MAX_RECENTS = 8

const storageKey = (userId) => `ambunet:recents:${userId}`

export const getRecentPages = (userId) => {
  if (!userId) return []
  try {
    const stored = JSON.parse(localStorage.getItem(storageKey(userId)) ?? '[]')
    return stored
      .map(({ id }) => getEntryById(id))
      .filter(Boolean)
      .slice(0, MAX_RECENTS)
  } catch {
    return []
  }
}

export const recordPageVisit = (userId, pathname) => {
  if (!userId) return
  const entry = getEntryByPath(pathname)
  // Only registered pages are worth remembering, and Home is always a click
  // away anyway. Detail pages resolve to their parent list via the prefix
  // match in getEntryByPath.
  if (!entry || entry.path === '/') return
  try {
    const key = storageKey(userId)
    const stored = JSON.parse(localStorage.getItem(key) ?? '[]')
    const next = [
      { id: entry.id, ts: Date.now() },
      ...stored.filter((item) => item.id !== entry.id),
    ].slice(0, MAX_RECENTS)
    localStorage.setItem(key, JSON.stringify(next))
  } catch {
    // Private browsing / blocked storage: recents just stay empty
  }
}

// Mount once inside the router (MainFrame) to keep recents up to date.
export const RecentPagesTracker = ({ userId }) => {
  const location = useLocation()
  useEffect(() => {
    recordPageVisit(userId, location.pathname)
  }, [userId, location.pathname])
  return null
}
